import { convertToAmPmHours } from 'signin-app/helpers/time';
export const getDisplayHourValue = (locale, hour = 0) => {
    let amPmHours = {};
    if (locale === 'en_US') {
        amPmHours = convertToAmPmHours(hour);
    }
    const formattedHour = locale === 'en_US' ? amPmHours.hours : hour;
    return {
        hour: formattedHour,
        amPm: amPmHours.amPm,
    };
};
